function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.294 0v3.137H20v10.588h-3.138V20H3.138v-6.275H0V3.137h4.705V0h10.59zm.392 10.588H4.313v8.236h11.373v-8.236zm-2.549 5.098v1.177H6.863v-1.177h6.274zm0-3.137v1.176H6.863V12.55h6.274zm5.687-8.236H1.176v8.235l1.961.001V9.412h13.726l-.001 3.137h1.962V4.312zm-4.706-3.137H5.882v1.961h8.235v-1.96z",
  fill: "params(fill)",
  fillRule: "nonzero"
});

function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgPrint;